var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mt-1 mb-0 anamnesisBlock",
    attrs: {
      "id": 'an-' + _vm.anamnesis.anamnesis_type.shortcode,
      "data-testid": 'visit-medical-report-anamnesis-' + _vm.anamnesis.anamnesis_type.shortcode,
      "data-anamnesis-text": _vm.anamnesis.anamnesis_type.shortcode + ' - ' + _vm.anamnesis.anamnesis_type.name
    }
  }, [_c('vue-editor', {
    class: 'anamnesis-editor',
    attrs: {
      "id": 'anamnesis' + _vm.anamnesis.anamnesis_type.shortcode,
      "editorToolbar": _vm.customToolbar,
      "editorOptions": _vm.editorSettings
    },
    model: {
      value: (_vm.anamnesis.text),
      callback: function($$v) {
        _vm.anamnesis.text = $$v
      },
      expression: "anamnesis.text"
    }
  })], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a1299a2","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Visit/components/AnamnesisEditor.vue
// module id = 555
// module chunks = 0